import { lazy } from 'react'
import { Route, Switch } from 'react-router'
import ClipTrim from '../components/clip-trim'
import Welcome from '../components/welcome'
import CreationToolStep from '../types/steps'
import { GIF_MAKER } from './index'

const LegacyGifMaker = lazy(
    () => import(/* webpackChunkName: "gifMakerLegacy" */ '../../gif-maker/components/gif-maker')
)

const Create = lazy(() => import(/* webpackChunkName: "creationCreate" */ '../components/create'))
const CutOut = lazy(() => import(/* webpackChunkName: "creationCutOut" */ '../components/cut-out'))
const Animate = lazy(() => import(/* webpackChunkName: "creationAnimate" */ '../components/animate'))
const Upload = lazy(() => import(/* webpackChunkName: "creationUpload" */ '../components/upload'))

const GifMakerRoute = (props: any) => {
    return (
        <Switch>
            <Route
                exact
                path={`${GIF_MAKER}${CreationToolStep.route(CreationToolStep.Upload)}`}
                render={() => <Upload submitUrl={props.submitUrl} apiKey={props.apiKey} />}
            />
            <Route
                exact
                path={`${GIF_MAKER}${CreationToolStep.route(CreationToolStep.Animate)}`}
                render={() => <Animate />}
            />
            <Route
                exact
                path={`${GIF_MAKER}${CreationToolStep.route(CreationToolStep.CutOut)}`}
                render={() => <CutOut />}
            />
            <Route
                exact
                path={`${GIF_MAKER}${CreationToolStep.route(CreationToolStep.Create)}`}
                render={() => <Create />}
            />
            <Route
                exact
                path={`${GIF_MAKER}${CreationToolStep.route(CreationToolStep.VideoTrim)}`}
                render={() => <ClipTrim />}
            />
            <Route path={`${GIF_MAKER}/legacy/*`} render={() => <LegacyGifMaker {...props} />} />
            <Route exact path={GIF_MAKER} render={() => <Welcome />} />
        </Switch>
    )
}

export default GifMakerRoute
